<h1 mat-dialog-title>{{ title }}</h1>

<mat-dialog-content>
  <p>{{ body }}</p>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="onDismiss()">Annuleer</button>
  <button mat-raised-button color="primary" (click)="onConfirm()">Bevestig</button>
</mat-dialog-actions>
